export default {
      id: "eye-icon-usage",
      viewBox: "0 0 16 10",
      url: __webpack_public_path__ + "sprite.svg#eye-icon-usage",
      toString: function () {
        return this.url;
      }
    }